module.exports = __webpack_public_path__ + "img/epr@2x.62333af1.webp";